define([
  "jquery",
  "colorbox"],
function($) {

  var colorboxMessage = function(settings, okCallback, closedCallback) {

    var _settings = settings || {};
    /*
    Example of settings
    {
      title: "Remove Item",
      msg: "Are you sure you would like to remove this item?",
      cssClass: "error"
    }
    */

    var html = "";
    if (_settings.html) {
      html = _settings.html;
    } else {
      var cssClass = _settings.cssClass || "";
      var buttonSettings = _settings.buttons || {};
      var okId = "colorbox-ok";
      var okText = (buttonSettings.ok && buttonSettings.ok.text) || "Ok";

      html = "<div class='bdc-colorbox-confirm-modal'> " +
        "<div id='colorbox-confirm' class='bdc-colorbox-confirm " + cssClass + "'>" +
        "<h3 id='title' class='bdc-colorbox-confirm-title " + cssClass + "'>" + _settings.title + "</h3>" +
        "<p id='msg' class='bdc-colorbox-confirm-message " + cssClass + "'>" + settings.msg + "</p>" +
        "<div class='bdc-colorbox-confirm-buttons " + cssClass + "'>" +
        "<button id='" + okId + "' class='bdc-btn bdc-colorbox-confirm-ok " + cssClass + "'>" + okText + "</button>" +
        "</div>" +
        "</div>" +
        "</div>";
      _settings.okElementId = okId;
    }

    var registerCallbacks = function (okHandler) {
      var ok = document.getElementById(okHandler.elementId);
      if (ok) {
        ok.onclick = function () {
          okHandler.callback && okHandler.callback.call(this);
          $.colorbox.close();
        };
      }
    }

    var okHandler = { elementId: _settings.okElementId, callback: okCallback };

    $.colorbox({
      html: html,
      transition: "none",
      maxWidth: "95%",
      maxHeight: "95%",
      onComplete: function () {
        $.colorbox.resize();
        registerCallbacks(okHandler);
      },
      onClosed: function () {
        if (closedCallback && !!( closedCallback && closedCallback.constructor && closedCallback.call && closedCallback.apply )) {
          closedCallback();
        }
      }
    });

  };

  return colorboxMessage;
});
